import { render, staticRenderFns } from "./faturaxslt.vue?vue&type=template&id=f43a18a6&"
import script from "./faturaxslt.vue?vue&type=script&lang=js&"
export * from "./faturaxslt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports